export default {
  methods: {
    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // 设置默认日期范围
    setDefaultDate() {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();

      let lastMonth, lastMonthYear;
      if (currentMonth === 0) {
        lastMonth = 11;
        lastMonthYear = currentYear - 1;
      } else {
        lastMonth = currentMonth - 1;
        lastMonthYear = currentYear;
      }

      const startDate = new Date(lastMonthYear, lastMonth, 1);
      const endDate = new Date(currentYear, currentMonth + 1, 0);

      this.value1 = [this.formatDate(startDate), this.formatDate(endDate)];
      this.search.start_time = this.value1[0];
      this.search.end_time = this.value1[1];
    }
  }
};